import { Icon as AvatarIcon } from '@/components/Custom/Avatar';
import Box from '@/components/Unistyles/Box';
import Text from '@/components/Unistyles/Text';
import TextInput from '@/components/Unistyles/TextInput';
import getOffsetColor from '@/utils/getOffsetColor';
import AvatarColorPicker from './AvatarColorPicker';

type NameAvatarFieldsProps = {
  avatarId?: string | null;
  color: string;
  errorMessage?: string | null;
  localAvatarUrl?: string | null;
  firstName: string;
  lastName: string;
  onChangeColor(color: string): void;
  onChangeLocalAvatarUrl(localAvatarUrl: string): void;
  onChangeFirstName(name: string): void;
  onChangeLastName(name: string): void;
};

export default function NameAvatarFields({
  avatarId,
  color,
  errorMessage,
  localAvatarUrl,
  firstName,
  lastName,
  onChangeColor,
  onChangeLocalAvatarUrl,
  onChangeFirstName,
  onChangeLastName,
}: NameAvatarFieldsProps) {
  return (
    <>
      <NameAvatarPicker
        {...{
          avatarId,
          color,
          localAvatarUrl,
          firstName,
          lastName,
          onChangeColor,
          onChangeLocalAvatarUrl,
        }}
      />

      <NameFields
        {...{
          firstName,
          lastName,
          onChangeFirstName,
          onChangeLastName,
          errorMessage,
        }}
      />
    </>
  );
}

export function NameFields({
  firstName,
  lastName,
  onChangeFirstName,
  onChangeLastName,
  errorMessage,
}: Pick<
  NameAvatarFieldsProps,
  | 'firstName'
  | 'lastName'
  | 'onChangeFirstName'
  | 'onChangeLastName'
  | 'errorMessage'
>) {
  return (
    <Box space="md">
      <TextInput
        autoCapitalize="words"
        enterKeyHint="done"
        placeholder="First Name"
        maxLength={35}
        value={firstName}
        onChangeText={onChangeFirstName}
      />
      <TextInput
        autoCapitalize="words"
        enterKeyHint="done"
        placeholder="Last Name"
        maxLength={35}
        value={lastName}
        onChangeText={onChangeLastName}
      />
      {errorMessage ? (
        <Text variant="error" center selectable>
          {errorMessage}
        </Text>
      ) : null}
    </Box>
  );
}

export function NameAvatarPicker({
  avatarId,
  color,
  localAvatarUrl,
  firstName,
  lastName,
  onChangeColor,
  onChangeLocalAvatarUrl,
}: Pick<
  NameAvatarFieldsProps,
  | 'avatarId'
  | 'color'
  | 'localAvatarUrl'
  | 'firstName'
  | 'lastName'
  | 'onChangeColor'
  | 'onChangeLocalAvatarUrl'
>) {
  return (
    <AvatarColorPicker
      avatarId={avatarId}
      avatarSize="xl"
      color={color}
      localAvatarUrl={localAvatarUrl}
      name={
        [firstName.trim(), lastName.trim()].filter(Boolean).join(' ') || 'Name'
      }
      nameSize="2xl"
      onChangeColor={onChangeColor}
      onChangeLocalAvatarUrl={onChangeLocalAvatarUrl}
    >
      <AvatarIcon
        name="camera-outline"
        size="4xl"
        color={getOffsetColor(color, false)}
      />
    </AvatarColorPicker>
  );
}
